import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {USER_CONTACT_CONFIG} from "../config/api";
import {LoaderService} from "./loader.service";

@Injectable({
    providedIn: 'root'
})
export class ContactInfoService {
    private config = USER_CONTACT_CONFIG;

    constructor(private http: HttpClient, public loaderService: LoaderService) {}

    saveUserContacts(first_name, last_name, email) {
        this.loaderService.show();
        return this.http.post<any>(this.config.save, {first_name, last_name, email});
    }

    onChangePassword(passwordOld, password) {
        this.loaderService.show();
        return this.http.post<any>(this.config.onChangePassword, {passwordOld, password});
    }

    onChangePin(pin, password) {
        this.loaderService.show();
        return this.http.post<any>(this.config.onChangePin, {pin, password});
    }
}
